export default __webpack_public_path__ + "afd1ae927e4553685b66fe41128d0b4b.js";